import SafeManage from './index'
export default [
  {
    path: '/manage',
    name: 'safe-manage',
    component: SafeManage
  },
]
